import React, { useEffect, useState } from "react";
import {
  Grid,
  Card,
  CardContent,
  Typography,
  // CircularProgress,
  Box,
} from "@mui/material";
import { Link } from "react-router-dom";

import { getCategories } from "../../../services/database/database_service";
import LoadingIndicator from "../components/LoadingIndicator";
import { useLanguage } from "../../../services/localization/LanguageContex";


function QuizScreen() {
  const { t,language } = useLanguage();
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [categories, setCategories] = useState([]);

  useEffect(() => {
    window.scrollTo(0, 0);
    const fetchCategories = async () => {
      try {
        const data = await getCategories(); // //data [documents,total]
        setCategories(data.documents);
      } catch (err) {
        setError("Could not fetch quiz. Please try again later.");
      } finally {
        setLoading(false);
      }
    };
    fetchCategories();
  }, []);

  return (
    <Box
      // sx={{
      //   p: 6,
      //   pt: 2,
      // }}
      sx={{ px: { xs: 3, sm: 6, md: 6 }, pt: 2, pb: 4 }}
    >
      <Typography variant="h4" gutterBottom align="center" sx={{ mb: 3 }}>
        {t("Explore our Quiz")}
      </Typography>

      {loading ? (
        <Box sx={{ display: "flex", justifyContent: "center", mt: 4 }}>
          <LoadingIndicator />
        </Box>
      ) : error ? (
        <Box sx={{ textAlign: "center", mt: 4 }}>
          <Typography variant="h6" color="error">
            {error}
          </Typography>
        </Box>
      ) : categories.length === 0 ? (
        <Box sx={{ textAlign: "center", mt: 4 }}>
          <Typography variant="h6" color="textSecondary">
            No quiz found.
          </Typography>
        </Box>
      ) : (
        <Grid container spacing={4}>
          {categories.map((cat) => (
            <Grid item xs={12} sm={6} md={4} lg={3} key={cat.$id}>
              {/* Wrap the card with a Link */}
              <Link
                to={`./${encodeURIComponent(cat.category)}`}
                style={{ textDecoration: "none" }}
              >
                <Card
                  sx={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    minHeight: 180,
                    boxShadow: 5,
                    "&:hover": {
                      cursor: "pointer",
                      boxShadow: 7,
                      transform: "translateY(-2px)",
                    },
                    pl: 5,
                    pr: 5,
                    borderRadius: "50%",
                  }}
                >
                  <CardContent
                    sx={{
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "center",
                    }}
                  >
                    <Typography
                      variant="subtitle1"
                      component="div"
                      align="center"
                      color="textPrimary"
                    >
                      {language === "en" 
                        ? cat.category.charAt(0).toUpperCase() + cat.category.slice(1)
                        : (t(cat.category) !== cat.category 
                            ? t(cat.category) 
                            : cat.category.charAt(0).toUpperCase() + cat.category.slice(1)
                          )
                      }
                    </Typography>
                  </CardContent>
                </Card>
              </Link>
            </Grid>
          ))}
        </Grid>
      )}
    </Box>
  );
}

export default QuizScreen;
